export default __webpack_public_path__ + "static/media/search-Pokemon.a964a521.png";